import React from 'react';
import './help.scss';

import IMAGE_1 from 'assets/home-page/help_image_1.png';
import IMAGE_2 from 'assets/home-page/help_image_2.png';
import IMAGE_3 from 'assets/home-page/help_image_3.png';
import {HeadingElement} from "components";
import {HashLink} from "react-router-hash-link";

const data: Array<{ heading: string, desc: string, image: any, link: string }> = [
    {
        heading: "Bring your business Ideas to life!",
        desc: "Planning a business can be frustrating and difficult sometimes. However, you can change that with assistance from industry experts at SBAJ.",
        image: IMAGE_1,
        link: "/business-education/#packages_plan"
    },
    {
        heading: "Get Your Business Started Today",
        desc: "We will guide you into successfully starting up your business. Therefore achieving your goal. ",
        image: IMAGE_2,
        link: "/business-education/#packages_start"
    },
    {
        heading: "Expand & Grow Your Business",
        desc: "Whether your a small startup, or a larger company seeking growth & expansion strategies; You can trust us to direct you on the right path.",
        image: IMAGE_3,
        link: "/business-education/#packages_grow"
    },
]
export const Help: React.FC = () => {

    return (
        <div className={'help'}>
            <div className="help_wrapper max">
                <div className="help_wrapper_top">
                    <div className="help_wrapper_top_left">
                        <HeadingElement/>
                        <div className="help_wrapper_top_left_top">
                            <h1>How Can We Help Your Business?</h1>

                        </div>
                    </div>
                    <div className="help_wrapper_top_right">
                        <p>
                            The Small Business Association of Jamaica is a non-profit membership 
                            organization that advocates for small businesses in Jamaica, 
                            helping them to grow and become successful.  
                        </p>
                    </div>
                    <svg className={'help_poly-bottom'} height="42" fill="none" xmlns="http://www.w3.org/2000/svg"/>
                </div>
                <div className="help_wrapper_bottom">
                    {data.map(({heading, desc, image, link}, index) => (
                        <div className="help_card" key={heading+index}>
                            <div className="help_card_img">
                                <img src={image} alt=""/>
                            </div>
                            <div className="help_card_content">
                                <h1>{heading}</h1>
                                <p>{desc}</p>

                                <div className={'help_card_content_cta'}><HashLink
                                    smooth to={link}>Let's Go</HashLink>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

